export default [
  "loginForm.username",
  "loginForm.provider",
  "loginForm.remembered",
  "loginForm.device",
  "intl.locale"
]